import axios from "axios"

axios.interceptors.response.use(res => {
    const data = res.data

    if (data.error) {
        return {error: data.error}
    }

    return data
}, ({response, message}) => {
    let {error} = ((response || {}).data || {})

    // if (__IS_PRODUCTION__) {
    //   rollbar.error(error)
    // }
    if (!error) {
        error = {message: response.data}
    }

    return {error}
})

